import React, {useState} from 'react';
import './login-tile.css';
import { Link } from 'react-router-dom';

const LoginTile = ({type, handleSubmit}) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const link = type === 'login' ? <Link to='/resetPassword'>Forgot Password?</Link> :
            <Link to='/Login'>Already Have an Account? Sign in Here</Link>

    return (
        <div className = 'login-container'>
            {type === 'login' ? <h2>Login</h2> : <h2>Sign Up</h2>}
            <div className = 'login-box' >
                <form onSubmit = {(e) => handleSubmit(e, email, password)}>
                    <div class='input-container'> 
                        <label className='input-label'>Email</label>
                        <input
                            className='login-input'
                            type='email'
                            onChange={(e) => setEmail(e.target.value)}
                            value={email}
                        />
                    </div>
                    <div class='input-container'>
                        <label className='input-label'>Password</label>
                        <input
                            className='login-input'
                            type='password'
                            onChange={(e) => setPassword(e.target.value)}
                            value={password}
                        />
                    </div>
                    <button type='submit' className='login-button'>
                        {type === 'login' ? 'Login' : 'Sign Up'}
                    </button>     
                </form>       
                <div className='forgot-password'>
                  {link}
                </div>
            </div>
        </div>
    );
}

export default LoginTile